import React from 'react';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { makeStyles } from '@material-ui/core/styles';
import Button from '../Basic/Button';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getIsShrinkSidebar } from '../../stores/sidebar/getters';
import { isMobile } from '../../helpers/mobile-detect';
import TooltipEnclosure from '../TooltipEnclosure';

const useStyles = makeStyles(() => ({
  root: {
    height: 40,
  },
  TooltipHolder: {},
}));

function TooltipHolder({ title, children, isDrawer = false }) {
  const classes = useStyles();
  const shrinkSidebar = useSelector(getIsShrinkSidebar);

  if (!isDrawer) {
    return <>{children}</>;
  }

  if (isMobile) {
    return <>{children}</>;
  }

  if (!shrinkSidebar) {
    return <>{children}</>;
  }

  return (
    <TooltipEnclosure
      title={title}
      className={`${classes.TooltipHolder} ${
        shrinkSidebar ? 'shrinkSidebar' : ''
      }`}
    >
      {children}
    </TooltipEnclosure>
  );
}

const CreateButton = ({ isDrawer = false }) => {
  const history = useHistory();
  const classes = useStyles();

  const handleRedirect = () => {
    history.push(`/create-algo/`, {
      from: window.location.hash,
    });
  };

  return (
    <TooltipHolder title="Create Algo" isDrawer={isDrawer}>
      <Button
        capitalized
        variant="contained"
        startIcon={<AddCircleIcon />}
        color="primary"
        className={`${classes.root} create-button btn--contained btn--primary`}
        onClick={handleRedirect}
      >
        <span className="create-button__text">Create Algo</span>
      </Button>
    </TooltipHolder>
  );
};

export default CreateButton;
